<template>
  <div class="cec-header p-3 d-flex align-items-center justify-content-between text-white sticky-top">
    <div class="d-flex align-items-center">
      <div class="cec-header__icon mr-3">
        <i :class="icon"></i>
      </div>

      <div>
        <h5 class="mb-0 font-weight-bold">{{ titulo }}</h5>
        <small class="opacity-75">
          <slot name="subtitulo">{{ subtitulo }}</slot>
        </small>
      </div>
    </div>

    <div class="cec-header__bar d-flex align-items-center rounded-pill p-1">
      <slot name="acoes"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeaderPadrao',
  props: {
    icon: { type: String, required: true },       // ex: "fa fa-shopping-cart"
    titulo: { type: String, required: true },
    subtitulo: { type: String, default: '' }
  }
}
</script>
<style>
  :root{
  --cec-header-gradient: linear-gradient(235deg, #343a40 0%, #245483   100%);
}

/* CASCA */
.cec-header{
  background: var(--cec-header-gradient) !important;
  border-bottom: 1px solid rgba(255,255,255,0.1);
  border-radius: 12px;
}

/* ÍCONE “embrulhado” igual ao Caixa */
.cec-header__icon{
  width: 45px;
  height: 45px;
  background: rgba(255,255,255,0.15);
  border-radius: 12px;
  display:flex;
  align-items:center;
  justify-content:center;
  font-size: 1.4rem;
}

/* PILL DA DIREITA (a “caixa” que envolve os botões) */
.cec-header__bar{
  background: rgba(255,255,255,0.10);
}

/* helpers caso use no conteúdo */
.cec-header .opacity-75{ opacity:.75; }
.cec-header .border-white-20{ border-color: rgba(255,255,255,0.2) !important; }

/* Base "glass" */
/* Base: neutro escuro (NÃO glass) */
.btn-glass {
  border-radius: 999px !important;
  font-weight: 800;
  letter-spacing: .3px;
  padding: .45rem 1.05rem !important;

  /* estado normal: discreto */
  background: rgba(0, 0, 0, 0.18) !important;
  border: 1px solid rgba(255,255,255,0.14) !important;
  color: rgba(255,255,255,0.88) !important;

  box-shadow: none !important;
  transition: transform .12s ease, background-color .12s ease, color .12s ease, border-color .12s ease, box-shadow .12s ease;
}

/* Hover: aí sim fica "glass" + destaque */
.btn-glass:hover {
  transform: translateY(-1px);
  background: rgba(255, 255, 255, 0.12) !important;
  border-color: rgba(255,255,255,0.22) !important;

  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);

  box-shadow: 0 8px 18px rgba(0,0,0,0.18) !important;
  text-decoration: none;
}

/* Cores por tema (no hover vira sólido/forte) */
.btn-glass-warning:hover {
  background: rgba(255, 193, 7, 0.92) !important;
  border-color: rgba(255, 193, 7, 0.65) !important;
  color: #212529 !important;
}

.btn-glass-danger:hover {
  background: rgba(220, 53, 69, 0.92) !important;
  border-color: rgba(220, 53, 69, 0.65) !important;
  color: #fff !important;
}

.btn-glass-info:hover {
  background: rgba(23, 162, 184, 0.92) !important;
  border-color: rgba(23, 162, 184, 0.65) !important;
  color: #fff !important;
}

.btn-glass-success:hover {
  background: rgba(40, 167, 69, 0.92) !important;
  border-color: rgba(40, 167, 69, 0.65) !important;
  color: #fff !important;
}

.btn-glass-primary:hover {
  background: rgba(0, 123, 255, 0.92) !important;
  border-color: rgba(0, 123, 255, 0.65) !important;
  color: #fff !important;
}

/* Pressionado */
.btn-glass:active {
  transform: translateY(0px);
  box-shadow: 0 4px 10px rgba(0,0,0,0.14) !important;
}


</style>


// WEBPACK FOOTER //
// src/components/Cec/HeaderPadrao.vue